import { render } from "./EditAddBescStep2.vue?vue&type=template&id=001df028&scoped=true&ts=true"
import script from "./EditAddBescStep2.vue?vue&type=script&lang=ts"
export * from "./EditAddBescStep2.vue?vue&type=script&lang=ts"

import "./EditAddBescStep2.vue?vue&type=style&index=0&id=001df028&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001df028"]])

export default __exports__